import { Injectable } from '@angular/core';
import { FileInfo, GalaxyImageUploaderService, UploadResponse } from '@vendasta/galaxy/uploader';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ReleaseFormStubUploadService extends GalaxyImageUploaderService {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  buildRequest(fileInfo: FileInfo): Observable<UploadResponse> {
    return of('placeholder-to-avoid-upload').pipe(
      map((url: string) => {
        return {
          data: {
            url,
          },
        };
      }),
    );
  }
}
